import React from "react";

export function InstitutionPatientBackButton({ onClick }) {
  return <button type="button" className="topbar-back" onClick={onClick} aria-label="Back to Patients"><img src="/icons/medical-institution/chevron_back.svg" alt="" /></button>;
}

export function InstitutionPatientPageHeader({ title, onBack, actions = null, className = "", showTitle = true }) {
  if (!showTitle) {
    return <div className={`w-full flex items-center justify-between pointer-events-auto ${className}`.trim()}>
      <InstitutionPatientBackButton onClick={onBack} />
      {actions ? <div className="institution-profile-cover-actions flex items-center gap-3">{actions}</div> : null}
    </div>;
  }

  return <div className={`medical-institution-create-header ${className}`.trim()}>
    <div className="medical-institution-title-row"><InstitutionPatientBackButton onClick={onBack} />{showTitle ? <h1 className="text-headline-small text-on-surface">{title}</h1> : null}</div>
    {actions ? <div className="medical-institution-create-actions">{actions}</div> : null}
  </div>;
}
